import { Grid } from "@mui/material";
import CustomSelect from "../../../../../../../../components/CustomSelect";
import Input from "../../../../../../../../components/Input";
import {
  WEIGHT_TYPE_OPTS,
  VitalFormik,
  WEIGHT_METHOD_OPTS,
  WEIGHT_UNIT_OPTS,
  FLAG_OPTS,
} from "../vital-constant";
import { PatientVital } from "../../../../../../../../services";

interface weightFieldProps {
  formik: VitalFormik;
  ind: number;
}

const WeightFields = ({ formik, ind }: weightFieldProps) => {
  const activeVital =
    ind !== -1 ? formik.values?.patientVitals?.[ind] : undefined;

  const isSelected = activeVital?.selected ?? false;

  const getKey = (k: keyof PatientVital) => `patientVitals.${ind}.${k}`;

  const getError = (key: keyof PatientVital) => {
    const touched = (formik.touched.patientVitals as any)?.[ind]?.[key];
    const error = (formik.errors.patientVitals as any)?.[ind]?.[key];
    return touched && error ? String(error) : undefined;
  };

  const selectHandleChange = (k: keyof PatientVital, v: string | null) => {
    formik.setFieldValue(getKey(k), v);
  };

  return (
    <Grid
      container
      sx={{
        gap: 2,
      }}
    >
      <Grid size={1.8}>
        <CustomSelect
          name={getKey("unit")}
          placeholder="LBS"
          required={isSelected}
          error={getError("unit")}
          options={WEIGHT_UNIT_OPTS}
          value={activeVital?.unit}
          onChange={(v) => selectHandleChange("unit", v)}
          handleBlur={formik.handleBlur}
        />
      </Grid>
      <Grid size={2.6}>
        <Input
          required={isSelected}
          error={getError("value")}
          textFieldProps={{
            name: getKey("value"),
            placeholder: "e.g. 150 (lbs)",
            value: activeVital?.value,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
          }}
        />
      </Grid>
      <Grid size={1.8}>
        <CustomSelect
          name={getKey("method")}
          placeholder="Dry"
          required={isSelected}
          error={getError("method")}
          options={WEIGHT_METHOD_OPTS}
          value={activeVital?.method}
          onChange={(v) => selectHandleChange("method", v)}
          handleBlur={formik.handleBlur}
        />
      </Grid>
      <Grid size={2.6}>
        <CustomSelect
          name={getKey("type")}
          placeholder="Pre-Dialysis"
          required={isSelected}
          error={getError("type")}
          options={WEIGHT_TYPE_OPTS}
          value={activeVital?.type}
          onChange={(v) => selectHandleChange("type", v)}
          handleBlur={formik.handleBlur}
        />
      </Grid>
      <Grid size={1.8}>
        <CustomSelect
          name={getKey("flag")}
          placeholder="Flag"
          required={isSelected}
          error={getError("flag")}
          options={FLAG_OPTS}
          value={activeVital?.flag}
          onChange={(v) => selectHandleChange("flag", v)}
          handleBlur={formik.handleBlur}
        />
      </Grid>
    </Grid>
  );
};

export default WeightFields;
